import { NgModule } from '@angular/core';
import { NimbusMaterialPageBodyDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-body.directive';
import { NimbusMaterialPageCardDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-card.directive';
import { NimbusMaterialPageFooterDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-footer.directive';
import { NimbusMaterialPageHeaderGroupSelectorCardDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-header-group-selector-card.directive';
import { NimbusMaterialPageHeaderDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-header.directive';
import { NimbusMaterialPageTableCardHeaderDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-table-card-header.directive';
import { NimbusMaterialPageTableCardDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-table-card.directive';
import { NimbusMaterialPageTableDetailsCardDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-table-details-card.directive';
import { NimbusMaterialPageDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page.directive';
import { NimbusMaterialPageHeaderActionsCardDirective } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page-header-actions-card.directive';

@NgModule({
  exports: [
    NimbusMaterialPageDirective,
    NimbusMaterialPageBodyDirective,
    NimbusMaterialPageCardDirective,
    NimbusMaterialPageHeaderDirective,
    NimbusMaterialPageHeaderActionsCardDirective,
    NimbusMaterialPageHeaderGroupSelectorCardDirective,
    NimbusMaterialPageFooterDirective,
    NimbusMaterialPageTableDetailsCardDirective,
    NimbusMaterialPageTableCardDirective,
    NimbusMaterialPageTableCardHeaderDirective,
  ],
  declarations: [
    NimbusMaterialPageDirective,
    NimbusMaterialPageBodyDirective,
    NimbusMaterialPageCardDirective,
    NimbusMaterialPageHeaderDirective,
    NimbusMaterialPageHeaderActionsCardDirective,
    NimbusMaterialPageHeaderGroupSelectorCardDirective,
    NimbusMaterialPageFooterDirective,
    NimbusMaterialPageTableDetailsCardDirective,
    NimbusMaterialPageTableCardDirective,
    NimbusMaterialPageTableCardHeaderDirective,
  ],
})
export class NimbusMaterialPageModule {}
